import { useLegacyQueryParams } from '../hooks/useLegacyQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
export const WithLegacyQueryParamsContext = Component => {
  const Wrapper = props => {
    const queryParams = useLegacyQueryParams();
    return /*#__PURE__*/_jsx(Component, Object.assign({
      queryParams: queryParams
    }, props));
  };
  Wrapper.displayName = 'WithLegacyQueryParamsContext';
  return Wrapper;
};